var s;(function(x){x.xxs="xxs",x.xs="xs",x.sm="sm",x.md="md",x.lg="lg",x.xl="xl"})(s||(s={}));export{s as ButtonSize};
